import { useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { usePlayer } from "@/context/PlayerContext";
import { Cover, PlayPauseIcon } from "./PlayerBits";
import { FullPlayer } from "./FullPlayer";
import { PLAYER } from "@/constants/testIds";

export const MiniPlayer = () => {
  const { track, playing, loading, time, toggle, close } = usePlayer();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  if (!track || pathname.startsWith("/shorts")) return null;
  const pct = time.duration ? (time.current / time.duration) * 100 : 0;

  return (
    <>
      <div data-testid={PLAYER.mini} className="fixed inset-x-0 bottom-[68px] md:bottom-0 z-40 px-2 md:px-0 animate-rise">
        <div className="relative mx-auto max-w-6xl overflow-hidden rounded-2xl md:rounded-none border border-white/10 md:border-x-0 md:border-b-0 bg-[#0D0E15]/95 backdrop-blur-xl shadow-[0_-10px_30px_rgba(0,0,0,0.6)]">
          <div className="absolute inset-x-0 top-0 h-[2px] bg-white/10"><div className="h-full bg-nw-red transition-[width] duration-300" style={{ width: `${pct}%` }} /></div>
          <div className="flex items-center gap-3 p-2 pr-3">
            <button data-testid={PLAYER.expand} onClick={() => setOpen(true)} className="flex min-w-0 flex-1 items-center gap-3 text-left">
              <Cover track={track} className="h-11 w-11 rounded-lg" />
              <div className="min-w-0">
                <p data-testid={PLAYER.title} className="truncate font-display text-sm font-semibold text-white">{track.title}</p>
                <p data-testid={PLAYER.artist} className="truncate text-xs text-slate-400">{track.artist_name}</p>
              </div>
            </button>
            <button data-testid={PLAYER.toggle} onClick={toggle} aria-label={playing ? "Pause" : "Play"}
              className="grid h-10 w-10 place-items-center rounded-full bg-nw-red text-white shadow-[0_0_15px_rgba(255,30,39,0.5)] transition-transform hover:scale-105 active:scale-95">
              <PlayPauseIcon playing={playing} loading={loading} />
            </button>
            <button data-testid={PLAYER.close} onClick={close} aria-label="Close player" className="p-1 text-slate-500 hover:text-white transition-colors"><X className="h-4 w-4" /></button>
          </div>
        </div>
      </div>
      <FullPlayer open={open} onOpenChange={setOpen} />
    </>
  );
};
